import React, { FC } from 'react';
import { Row, Typography } from 'components';
import { Badge } from 'antd';
import styles from './styles.module.scss';

const { Text } = Typography;

export type LeadStatusType = 'MANUAL_REVIEW' | 'PROCESSING' | 'PENDING_INFORMATION' | 'CONVERTED' | 'REJECTED';

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};

export const DEFAULT_STATUS: StatusMapType = {
  label: 'Unknown',
  color: '#f0f0f0',
  dotColor: 'gray',
};

export const LEAD_STATUS_MAPPING: Record<LeadStatusType, StatusMapType> = {
  MANUAL_REVIEW: {
    label: 'Manual Review',
    color: '#E6F0FF',
    dotColor: 'blue',
  },
  PROCESSING: {
    label: 'Processing',
    color: '#FFEEE0',
    dotColor: 'orange',
  },
  CONVERTED: {
    label: 'Converted',
    color: '#E0FAEC',
    dotColor: 'green',
  },
  PENDING_INFORMATION: {
    label: 'Pending Information',
    color: '#f9f9d1',
    dotColor: '#d2d236',
  },
  REJECTED: {
    label: 'Rejected',
    color: '#fff2f0',
    dotColor: 'red',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: string; // now accepting unknown status types too
}

export const LeadStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = LEAD_STATUS_MAPPING[type as LeadStatusType] ?? DEFAULT_STATUS;

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
